import { invokeEditorFunction as publicInvokeEditorFunction } from './functions-v1-editor-function-editor-functions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const invokeEditorFunction: MaybeContext<
  BuildRESTFunction<typeof publicInvokeEditorFunction> &
    typeof publicInvokeEditorFunction
> = /*#__PURE__*/ createRESTModule(publicInvokeEditorFunction);

export {
  EditorFunction,
  InvokeEditorFunctionRequest,
  InvokeEditorFunctionResponse,
} from './functions-v1-editor-function-editor-functions.universal.js';
export { InvokeEditorFunctionApplicationErrors } from './functions-v1-editor-function-editor-functions.universal.js';
